// @flow
import types from '../dev-support/devSupportConstants';

const INIT_STATE = {
    devSupportTicketList: [],
    devSupportTicket: {},
    comments: [],
    // Ticket the comments in flight / on screen belong to.
    commentsTicketId: null,
    commentsLoading: false,
    commentSaving: false,
    // Global (list / save / delete) loader vs. reading-pane loader: switching
    // the selected ticket must not blank the whole page.
    loading: false,
    ticketLoading: false,
    // Bumped on every list fetch; lets the page wait for the refetch it asked for.
    listVersion: 0,
    success: null,
    error: null
};

// The comments answer for a ticket the reading pane has since left (the
// comments are fetched beside the ticket, not after it).
const isStaleComments = (state, action) =>
    action.ticketId !== undefined && action.ticketId !== state.commentsTicketId;

const DevSupportTicket = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            }
        case types.CLEAR_TICKET:
            return {
                ...state,
                devSupportTicket: {},
                comments: [],
                commentsTicketId: null,
                commentsLoading: false,
                commentSaving: false,
                ticketLoading: false
            }
        //List
        case types.GET_DEV_SUPPORT_TICKETS:
            return {
                ...state,
                loading: true
            };
        case types.GET_DEV_SUPPORT_TICKETS_SUCCESS:

            return {
                ...state,
                devSupportTicketList: action.payload.data.items,
                listVersion: state.listVersion + 1,
                loading: false,
                error: null
            };
        case types.GET_DEV_SUPPORT_TICKETS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //List

        //Change State
        case types.PATCH_DEV_SUPPORT_TICKET_STATE:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.PATCH_DEV_SUPPORT_TICKET_STATE_SUCCESS:

            var list = [...state.devSupportTicketList].map((item, index) => {
                if (item.id === action.payload.id) {
                    return {
                        ...item,
                        state: action.payload.newState
                    }
                }
                return item;
            });

            return {
                ...state,
                devSupportTicketList: list,
                loading: false,
                success: 'DEV.SUPPORT.STATE.UPDATE.SUCESS',
                error: null
            };
        case types.PATCH_DEV_SUPPORT_TICKET_STATE_FAILED:
            return {
                ...state,
                error: action.payload,
                success: null,
                loading: false
            };
        //Change State

        //dev support ticket
        case types.GET_DEV_SUPPORT_TICKET:
            return {
                ...state,
                ticketLoading: true
            };
        case types.GET_DEV_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                devSupportTicket: action.payload.data,
                ticketLoading: false,
                error: null
            };
        case types.GET_DEV_SUPPORT_TICKET_FAILED:
            return {
                ...state,
                error: action.payload,
                ticketLoading: false
            };

        case types.POST_DEV_SUPPORT_TICKET:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.POST_DEV_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                success: 'DEV.SUPPORT.TICKET.CREATED.SUCESS',
                loading: false,
                error: null
            };
        case types.POST_DEV_SUPPORT_TICKET_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        case types.PATCH_DEV_SUPPORT_TICKET:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.PATCH_DEV_SUPPORT_TICKET_SUCCESS: {
            // Keep the list row and the open ticket in step with what was saved,
            // so the left pane reflects the edit without a refetch.
            const { id, changes } = action.payload;
            const applied = {
                ...(changes.title !== undefined && { title: changes.title }),
                ...(changes.description !== undefined && { description: changes.description }),
                ...(changes.state !== undefined && { state: changes.state }),
            };
            return {
                ...state,
                devSupportTicketList: state.devSupportTicketList.map(item =>
                    item.id === id ? { ...item, ...applied } : item
                ),
                devSupportTicket: state.devSupportTicket && state.devSupportTicket.id === id
                    ? { ...state.devSupportTicket, ...applied }
                    : state.devSupportTicket,
                success: 'DEV.SUPPORT.TICKET.UPDATED.SUCESS',
                loading: false,
                error: null
            };
        }
        case types.PATCH_DEV_SUPPORT_TICKET_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        //dev support ticket

        //delete dev support ticket
        case types.DELETE_DEV_SUPPORT_TICKET:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.DELETE_DEV_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                devSupportTicketList: state.devSupportTicketList.filter(item => item.id !== action.payload),
                success: 'DEV.SUPPORT.TICKET.DELETED.SUCCESS',
                loading: false,
                error: null
            };
        case types.DELETE_DEV_SUPPORT_TICKET_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        //delete dev support ticket

        //comments
        case types.GET_DEV_SUPPORT_TICKET_COMMENTS:
            return {
                ...state,
                commentsTicketId: action.ticketId ?? state.commentsTicketId,
                commentsLoading: true,
            };
        case types.GET_DEV_SUPPORT_TICKET_COMMENTS_SUCCESS:
            if (isStaleComments(state, action)) return state;
            return {
                ...state,
                comments: Array.isArray(action.payload) ? action.payload : [],
                commentsLoading: false,
                error: null,
            };
        case types.GET_DEV_SUPPORT_TICKET_COMMENTS_FAILED:
            if (isStaleComments(state, action)) return state;
            return {
                ...state,
                commentsLoading: false,
                error: action.payload,
            };

        case types.POST_DEV_SUPPORT_TICKET_COMMENT:
            return {
                ...state,
                commentSaving: true,
                success: null,
            };
        case types.POST_DEV_SUPPORT_TICKET_COMMENT_SUCCESS: {
            const { ticketId, comment } = action.payload;
            return {
                ...state,
                comments: comment ? [...state.comments, comment] : state.comments,
                devSupportTicketList: state.devSupportTicketList.map(item =>
                    item.id === ticketId ? { ...item, commentCount: (item.commentCount ?? 0) + 1 } : item
                ),
                commentSaving: false,
                success: 'DEV.SUPPORT.TICKET.COMMENT.CREATED.SUCCESS',
                error: null,
            };
        }
        case types.POST_DEV_SUPPORT_TICKET_COMMENT_FAILED:
            return {
                ...state,
                commentSaving: false,
                error: action.payload,
            };

        case types.DELETE_DEV_SUPPORT_TICKET_COMMENT:
            return {
                ...state,
                success: null,
            };
        case types.DELETE_DEV_SUPPORT_TICKET_COMMENT_SUCCESS: {
            const { ticketId, commentId } = action.payload;
            return {
                ...state,
                comments: state.comments.filter(c => c.id !== commentId),
                devSupportTicketList: state.devSupportTicketList.map(item =>
                    item.id === ticketId ? { ...item, commentCount: Math.max(0, (item.commentCount ?? 0) - 1) } : item
                ),
                success: 'DEV.SUPPORT.TICKET.COMMENT.DELETED.SUCCESS',
                error: null,
            };
        }
        case types.DELETE_DEV_SUPPORT_TICKET_COMMENT_FAILED:
            return {
                ...state,
                error: action.payload,
            };
        //comments

        default:
            return state;
    }
};

export default DevSupportTicket;
